module.exports = __webpack_public_path__ + "static/media/pdf_ico.1f54e16b.svg";